
const toggleMenu = (e) => {
  let body = document.getElementsByTagName('body')[0]
  let open = body.classList.contains('open')
  const toggle = e.currentTarget

  if (!open) {
    open = true
    body.classList.add('open')
    toggle.classList.add('active')
    toggle.setAttribute('aria-expanded', 'true')
  } else {
    body.classList.remove('open')
    toggle.classList.remove('active')
    toggle.setAttribute('aria-expanded', 'false')
    open = false
  }
}

const navigation = (menuTrigger) => {
  menuTrigger.addEventListener('click', toggleMenu, false)
}

export {
  navigation
}
